/**
 * Article main class for FAQ
 */
import { BaseAPI } from '../BaseAPI'

class AuthClass extends BaseAPI {

  /**
   *  @method: checkAuth method to check the authentication
   *  @params: none
   *  @output: status in object 
   */

  checkAuth = () => {
     let postBody = {};
     return this.getData(`${this.baseURL}/login`, postBody);   

  }

}

export { AuthClass }
